import React from "react";

const LanguageSelector = ({ languageId, onSelectLanguage }) => {
  return (
    <div className="language-selector">
      <div
        onClick={() => {
          onSelectLanguage("en");
        }}
        className={`language ${languageId === "en" ? "active" : ""}`}
      >
        English
      </div>
      <div
        onClick={() => {
          onSelectLanguage("ar");
        }}
        className={`language ${languageId === "ar" ? "active" : ""}`}
      >
        عربى
      </div>
      <div
        onClick={() => {
          onSelectLanguage("he");
        }}
        className={`language ${languageId === "he" ? "active" : ""}`}
      >
        עִברִית
      </div>
    </div>
  );
};

export default LanguageSelector;



// WEBPACK FOOTER //
// ./application/frontend/src/containers/cabinet/LanguageSelector.jsx